import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=01fdf2b2&scoped=true&"
import script from "./SelectComponent.vue?vue&type=script&lang=js&"
export * from "./SelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=01fdf2b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fdf2b2",
  null
  
)

export default component.exports